import React from "react";
import {
  // react-icons prefixes every icon with "Lu" — aliasing back to the
  // plain Lucide names below so the rest of this file stays readable.

  // --- Original set, replaced 1:1 with the closest real Lucide icon ---
  LuMail as Mail,
  LuMapPin as MapPin,
  LuPhone as Phone,
  LuClock as Clock,
  LuCalendar as Calendar,
  LuUsers as Users,
  LuBook as Book,
  LuStar as Star,
  LuHeart as Heart,
  LuMap as Map,
  LuCheck as Check,
  LuBrush as Brush,
  LuShield as Shield,
  LuSparkles as Sparkles,
  LuWrench as Wrench,
  LuPen as Pen,
  LuCalculator as Calculator,
  LuLeaf as Leaf,
  LuMove as Move,
  LuPalette as Palette,
  LuGlobe as Globe,
  LuMessageCircle as MessageCircle,
  LuSun as Sun,
  LuHandHeart as HandHeart,
  LuRoute as Route,

  // --- Academics / subjects ---
  LuGraduationCap as GraduationCap,
  LuSchool as School,
  LuBookOpen as BookOpen,
  LuBookOpenText as BookOpenText,
  LuBookA as BookA,
  LuLibrary as Library,
  LuLibraryBig as LibraryBig,
  LuNotebookPen as NotebookPen,
  LuNotebook as Notebook,
  LuPencil as Pencil,
  LuPencilRuler as PencilRuler,
  LuRuler as Ruler,
  LuLanguages as Languages,
  LuSpellCheck as SpellCheck,
  LuAtom as Atom,
  LuFlaskConical as FlaskConical,
  LuMicroscope as Microscope,
  LuDna as Dna,
  LuTelescope as Telescope,
  LuTestTube as TestTube,
  LuSigma as Sigma,
  LuInfinity as InfinityIcon,
  LuPuzzle as Puzzle,

  // --- Arts / creativity ---
  LuPaintbrush as Paintbrush,
  LuPaintBucket as PaintBucket,
  LuPaintRoller as PaintRoller,
  LuPenTool as PenTool,
  LuScissors as Scissors,
  LuDrama as Drama,
  LuTheater as Theater,
  LuCamera as Camera,
  LuVideo as Video,
  LuClapperboard as Clapperboard,
  LuWandSparkles as WandSparkles,

  // --- Music ---
  LuMusic as Music,
  LuMusic2 as Music2,
  LuMusic3 as Music3,
  LuMusic4 as Music4,
  LuGuitar as Guitar,
  LuPiano as Piano,
  LuMic as Mic,
  LuMicVocal as MicVocal,
  LuHeadphones as Headphones,
  LuDiscAlbum as DiscAlbum,
  LuRadio as Radio,
  LuDrum as Drum,
  LuKeyboardMusic as KeyboardMusic,

  // --- Sport / movement ---
  LuDumbbell as Dumbbell,
  LuBike as Bike,
  LuFootprints as Footprints,
  LuVolleyball as Volleyball,
  LuTrophy as Trophy,
  LuMedal as Medal,
  LuAward as Award,
  LuTarget as Target,
  LuFlag as Flag,
  LuPersonStanding as PersonStanding,

  // --- Nature / animals / science ---
  LuLeafyGreen as LeafyGreen,
  LuFlower as Flower,
  LuFlower2 as Flower2,
  LuTreePine as TreePine,
  LuTreeDeciduous as TreeDeciduous,
  LuTrees as Trees,
  LuSprout as Sprout,
  LuBug as Bug,
  LuBird as Bird,
  LuFish as Fish,
  LuCat as Cat,
  LuDog as Dog,
  LuRabbit as Rabbit,
  LuSquirrel as Squirrel,
  LuTurtle as Turtle,
  LuSnail as Snail,
  LuWorm as Worm,
  LuPawPrint as PawPrint,
  LuShell as Shell,
  LuMountain as Mountain,
  LuMountainSnow as MountainSnow,
  LuWaves as Waves,
  LuDroplet as Droplet,
  LuDroplets as Droplets,
  LuRecycle as Recycle,

  // --- Weather / sky / seasons ---
  LuCloud as Cloud,
  LuCloudRain as CloudRain,
  LuCloudSun as CloudSun,
  LuCloudSnow as CloudSnow,
  LuSnowflake as Snowflake,
  LuUmbrella as Umbrella,
  LuRainbow as Rainbow,
  LuWind as Wind,
  LuSunrise as Sunrise,
  LuSunset as Sunset,
  LuMoon as Moon,
  LuMoonStar as MoonStar,

  // --- Space ---
  LuRocket as Rocket,
  LuSatellite as Satellite,
  LuOrbit as Orbit,
  LuSparkle as Sparkle,

  // --- Technology ---
  LuLaptop as Laptop,
  LuMonitor as Monitor,
  LuComputer as Computer,
  LuKeyboard as Keyboard,
  LuMouse as Mouse,
  LuPrinter as Printer,
  LuWifi as Wifi,
  LuCpu as Cpu,
  LuJoystick as Joystick,
  LuGamepad2 as Gamepad2,
  LuTablet as Tablet,

  // --- Communication / social ---
  LuMessageSquare as MessageSquare,
  LuUsersRound as UsersRound,
  LuUser as User,
  LuUserRound as UserRound,
  LuHandshake as Handshake,
  LuHeartHandshake as HeartHandshake,
  LuSmile as Smile,
  LuThumbsUp as ThumbsUp,
  LuMegaphone as Megaphone,
  LuSpeech as Speech,

  // --- Time / schedule ---
  LuCalendarDays as CalendarDays,
  LuCalendarCheck as CalendarCheck,
  LuTimer as Timer,
  LuHourglass as Hourglass,
  LuAlarmClock as AlarmClock,

  // --- Places / facilities ---
  LuBuilding as Building,
  LuBuilding2 as Building2,
  LuHouse as House,
  LuDoorOpen as DoorOpen,
  LuBackpack as Backpack,
  LuBus as Bus,
  LuBusFront as BusFront,
  LuCar as Car,
  LuTrainFront as TrainFront,
  LuCompass as Compass,
  LuSignpost as Signpost,

  // --- Food / health / safety ---
  LuApple as Apple,
  LuUtensils as Utensils,
  LuCookie as Cookie,
  LuCake as Cake,
  LuCoffee as Coffee,
  LuSalad as Salad,
  LuSandwich as Sandwich,
  LuHeartPulse as HeartPulse,
  LuStethoscope as Stethoscope,
  LuBandage as Bandage,
  LuShieldCheck as ShieldCheck,
  LuSiren as Siren,

  // --- Play / games / achievement ---
  LuBlocks as Blocks,
  LuToyBrick as ToyBrick,
  LuDices as Dices,
  LuPartyPopper as PartyPopper,
  LuGift as Gift,

  // --- Family / community ---
  LuBaby as Baby,
} from "react-icons/lu";

/**
 * All icons come from Lucide (via react-icons/lu). Each icon is a real
 * React component, so no more hand-drawn SVGs to maintain.
 *
 * Strapi's "icon.name" field should store one of the keys below exactly
 * (e.g. "graduation-cap", "book-open", "sun"). Unknown/empty names fall
 * back to a star.
 *
 * Usage: <IconByName name="graduation-cap" size={24} />
 */
const ICON_MAP = {
  // Original keys, kept for backward compatibility with existing content
  mail: Mail,
  pin: MapPin,
  phone: Phone,
  clock: Clock,
  calendar: Calendar,
  users: Users,
  book: Book,
  star: Star,
  heart: Heart,
  map: Map,
  check: Check,
  brush: Brush,
  shield: Shield,
  spark: Sparkles,
  tools: Wrench,
  pen: Pen,
  numbers: Calculator,
  leaf: Leaf,
  move: Move,
  palette: Palette,
  globe: Globe,
  message: MessageCircle,
  sun: Sun,
  hands: HandHeart,
  route: Route,

  // Academics / subjects
  "graduation-cap": GraduationCap,
  school: School,
  "book-open": BookOpen,
  "book-open-text": BookOpenText,
  "book-a": BookA,
  library: Library,
  "library-big": LibraryBig,
  "notebook-pen": NotebookPen,
  notebook: Notebook,
  pencil: Pencil,
  "pencil-ruler": PencilRuler,
  ruler: Ruler,
  languages: Languages,
  "spell-check": SpellCheck,
  atom: Atom,
  "flask-conical": FlaskConical,
  microscope: Microscope,
  dna: Dna,
  telescope: Telescope,
  "test-tube": TestTube,
  sigma: Sigma,
  infinity: InfinityIcon,
  puzzle: Puzzle,

  // Arts / creativity
  paintbrush: Paintbrush,
  "paint-bucket": PaintBucket,
  "paint-roller": PaintRoller,
  "pen-tool": PenTool,
  scissors: Scissors,
  drama: Drama,
  theater: Theater,
  camera: Camera,
  video: Video,
  clapperboard: Clapperboard,
  "wand-sparkles": WandSparkles,

  // Music
  music: Music,
  "music-2": Music2,
  "music-3": Music3,
  "music-4": Music4,
  guitar: Guitar,
  piano: Piano,
  mic: Mic,
  "mic-vocal": MicVocal,
  headphones: Headphones,
  "disc-album": DiscAlbum,
  radio: Radio,
  drum: Drum,
  "keyboard-music": KeyboardMusic,

  // Sport / movement
  dumbbell: Dumbbell,
  bike: Bike,
  footprints: Footprints,
  volleyball: Volleyball,
  trophy: Trophy,
  medal: Medal,
  award: Award,
  target: Target,
  flag: Flag,
  "person-standing": PersonStanding,

  // Nature / animals / science
  "leafy-green": LeafyGreen,
  flower: Flower,
  "flower-2": Flower2,
  "tree-pine": TreePine,
  "tree-deciduous": TreeDeciduous,
  trees: Trees,
  sprout: Sprout,
  bug: Bug,
  bird: Bird,
  fish: Fish,
  cat: Cat,
  dog: Dog,
  rabbit: Rabbit,
  squirrel: Squirrel,
  turtle: Turtle,
  snail: Snail,
  worm: Worm,
  "paw-print": PawPrint,
  shell: Shell,
  mountain: Mountain,
  "mountain-snow": MountainSnow,
  waves: Waves,
  droplet: Droplet,
  droplets: Droplets,
  recycle: Recycle,

  // Weather / sky / seasons
  cloud: Cloud,
  "cloud-rain": CloudRain,
  "cloud-sun": CloudSun,
  "cloud-snow": CloudSnow,
  snowflake: Snowflake,
  umbrella: Umbrella,
  rainbow: Rainbow,
  wind: Wind,
  sunrise: Sunrise,
  sunset: Sunset,
  moon: Moon,
  "moon-star": MoonStar,

  // Space
  rocket: Rocket,
  satellite: Satellite,
  orbit: Orbit,
  sparkle: Sparkle,

  // Technology
  laptop: Laptop,
  monitor: Monitor,
  computer: Computer,
  keyboard: Keyboard,
  mouse: Mouse,
  printer: Printer,
  wifi: Wifi,
  cpu: Cpu,
  joystick: Joystick,
  "gamepad-2": Gamepad2,
  tablet: Tablet,

  // Communication / social
  "message-square": MessageSquare,
  "users-round": UsersRound,
  user: User,
  "user-round": UserRound,
  handshake: Handshake,
  "heart-handshake": HeartHandshake,
  smile: Smile,
  "thumbs-up": ThumbsUp,
  megaphone: Megaphone,
  speech: Speech,

  // Time / schedule
  "calendar-days": CalendarDays,
  "calendar-check": CalendarCheck,
  timer: Timer,
  hourglass: Hourglass,
  "alarm-clock": AlarmClock,

  // Places / facilities
  building: Building,
  "building-2": Building2,
  house: House,
  "door-open": DoorOpen,
  backpack: Backpack,
  bus: Bus,
  "bus-front": BusFront,
  car: Car,
  "train-front": TrainFront,
  compass: Compass,
  signpost: Signpost,

  // Food / health / safety
  apple: Apple,
  utensils: Utensils,
  cookie: Cookie,
  cake: Cake,
  coffee: Coffee,
  salad: Salad,
  sandwich: Sandwich,
  "heart-pulse": HeartPulse,
  stethoscope: Stethoscope,
  bandage: Bandage,
  "shield-check": ShieldCheck,
  siren: Siren,

  // Play / games / achievement
  blocks: Blocks,
  "toy-brick": ToyBrick,
  dices: Dices,
  "party-popper": PartyPopper,
  gift: Gift,

  // Family / community
  baby: Baby,
};

/**
 * Resolves a Strapi icon name string to the matching Lucide component.
 * Usage: <IconByName name="graduation-cap" size={24} />
 * Falls back to a star if the name is unknown or empty.
 */
export default function IconByName({ name, size = 22 }) {
  const Cmp = ICON_MAP[name] || Star;
  return <Cmp size={size} strokeWidth={1.7} />;
}